import { useUserStore } from "~/store/UserStore";
import { useShepherd } from "vue-shepherd";
import { useI18n } from "vue-i18n";
import { useMenuStore } from "~/store/menu";
import { updateUserTours } from "~/api/user";

export const useTour = () => {
  const userStore = useUserStore();
  const menuStore = useMenuStore();
  const ids = ref({
    search_page: "tour-product-search",
    product_page: "tour-product-info",
  });
  const { t } = useI18n();
  const menuRefs = computed(() => menuStore.menuRefs);
  const isAuthenticated = computed(() => userStore.isAuthenticated);
  const user = computed(() => userStore.user);
  const tourStarted = ref(false);
  const tour = useShepherd({
    useModalOverlay: true,
  });

  const updateUserTour = async () => {
    await userStore.getUserData();
    const userTours = [tour.idX];
    localStorage.setItem(tour.idX, true);

    if (user.value?.tours?.length) {
      userTours.push(...user.value.tours);
    }
    updateUserTours(userTours);
  };
  const RemoveUserToursByIds = async ({ tourIds }) => {
    await userStore.getUserData();
    let userTours = [];
    if (user.value?.tours?.length) {
      const length = user.value?.tours?.length;
      for (let i = 0; i < length; i++) {
        if (!tourIds.includes(user.value.tours[i])) {
          userTours.push(user.value.tours[i]);
        }
      }

      updateUserTours(userTours);
    }
  };

  // must run this first
  const init = ({ idX }) => {
    tour.idX = idX;
  };
  const addSteps = (steps) => {
    tour.addSteps(steps);
  };
  const cancel = (updateUser = true) => {
    if (updateUser) {
      updateUserTour();
    }
    tour.cancel();
    // tour.destroy();
  };

  const startTour = async (isOnClick = false) => {
    // when user clicks show him the tour anyway, no check is needed
    if (isOnClick) {
      tour.start();
      return;
    }
    await userStore.getUserData();
    let tourShown = false;
    const tourId = localStorage.getItem(tour.idX);
    if (
      (user.value?.userId && tourId) ||
      (user.value?.tours?.length && user.value.tours.includes(tour.idX))
    ) {
      tourShown = true;
    }
    if (isAuthenticated.value && !tourShown && !tourStarted.value) {
      tourStarted.value = true;
      tour.start();
    }
  };
  const startTourBasic = () => {
    if (!tourStarted.value) {
      tourStarted.value = true;
      tour.start();
    }
  };

  const restart = async (tourIds) => {
    tourIds.forEach((tourId) => {
      localStorage.removeItem(tourId);
    });

    await RemoveUserToursByIds({ tourIds });
  };
  const useSearchPageButtons = () => ({
    cancel: {
      action: function () {
        menuRefs.value["Release"]?.classList?.remove("tour-pointing");
        menuRefs.value["Account"]?.classList?.remove("tour-pointing");
        menuRefs.value["child-ul-Account-0"]?.classList?.remove("tour-pointing");
        menuRefs.value["child-ul-Account-1"]?.classList?.remove("tour-pointing");
        updateUserTour();
        return tour.cancel();
      },
      secondary: true,
      text: t("common_button.exit"),
      classes: "danger-tour-btn",
    },
    next: {
      action: function () {
        return this.next();
      },
      text: t("common_button.next"),
      classes: "primary-tour-btn",
    },
    nextWithUpdate: {
      action: function () {
        // saving user data in local storage & node.js user
        updateUserTour();
        return this.next();
      },
      text: t("common_button.next"),
      classes: "primary-tour-btn",
    },
    back: {
      action: function () {
        return this.back();
      },
      text: t("common_button.prev"),
      classes: "neutral-tour-btn",
    },
  });

  const useButtons = () => ({
    cancel: {
      action: function () {
        updateUserTour();
        return tour.cancel();
      },
      secondary: true,
      text: t("common_button.exit"),
      classes: "neutral-tour-btn",
    },
    next: {
      action: function () {
        return this.next();
      },
      text: t("common_button.next"),
      classes: "primary-tour-btn",
    },
    nextWithUpdate: {
      action: function () {
        // saving user data in local storage & node.js user
        updateUserTour();
        return this.next();
      },
      text: t("common_button.next"),
      classes: "primary-tour-btn",
    },
    back: {
      action: function () {
        return this.back();
      },
      text: t("common_button.prev"),
    },
  });
  return {
    tourStarted,
    tour,
    init,
    addSteps,
    updateUserTour,
    startTour,
    cancel,
    useSearchPageButtons,
    useButtons,
    startTourBasic,
    restart,
    ids,
  };
};
